import React from "react";
import styled from "styled-components";
import Media from "react-media";
import Gettext from "../common/Gettext";
import { tournamentCurrency } from "../Icons/Kuchka";
import { CurrencySymbol } from "../Money";
import { rtl } from "../common/styled-mixins";

const Container = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;

  @media (max-width: 959px) {
    width: 448px;
  }

  @media (max-width: 480px) {
    width: 320px;
  }

  @media (max-width: 359px) {
    width: 288px;
  }
`;

const Text = styled.p`
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: ${({ theme }) => (theme.locale === "ar" ? "20px" : "16px")};
  line-height: 1.2;
  color: #717171;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  min-width: 100%;
  margin-bottom: 15px;
  background-color: transparent;
  overflow: hidden;
`;

const List = styled.ul``;

const Item = styled.li`
  direction: ${props => props.theme.direction};
  position: relative;
  display: block;
  margin-bottom: 20px;
  text-align: ${({ theme }) => (theme.direction === "rtl" ? "right" : "left")};

  &::before {
    content: "";
    position: absolute;
    ${rtl("left", "-17px")};
    top: 4px;
    display: block;
    width: 7px;
    height: 7px;
    background-color: ${({ theme }) => theme.accent};
    border-radius: 50%;
  }

  @media (max-width: 980px) {
    :before {
      ${rtl("left", "-14px")};
    }
  }

  @media (min-width: 960px) and (max-width: 1020px) {
    :before {
      ${rtl("left", "2px")}
    }

    > p:first-of-type {
      ${rtl("margin-left", "20px")};
    }
  }
`;

const TextPage = props => {
  const { locale } = props;
  // хардкод локалей, для которых есть папки с картинками
  const imgLocales = ["ar", "en", "hi", "id", "ph", "vn", "th", "es"];
  const images = (isMobile: boolean) => {
    if (isMobile) {
      return imgLocales.includes(locale)
        ? `${process.env.PUBLIC_URL}/images/about-tournaments/${
            process.env.REACT_APP_DEPLOY_TARGET
          }/${locale}/mobile`
        : `${process.env.PUBLIC_URL}/images/about-tournaments/${
            process.env.REACT_APP_DEPLOY_TARGET
          }/en/mobile`;
    }

    return imgLocales.includes(locale)
      ? `${process.env.PUBLIC_URL}/images/about-tournaments/${
          process.env.REACT_APP_DEPLOY_TARGET
        }/${locale}`
      : `${process.env.PUBLIC_URL}/images/about-tournaments/${
          process.env.REACT_APP_DEPLOY_TARGET
        }/en`;
  };

  return (
    <Container>
      <Media query="(max-width: 959px)">
        {isMobile => (
          <List>
            <Item>
              <Text>
                <Gettext>
                  A tournament is a traders' competition where you use a special
                  tournament account. Each tournament has its own goals that you
                  can achieve and get prizes. A user may participate in several
                  tournaments simultaneously.
                </Gettext>
              </Text>
            </Item>
            <Item>
              <Text>
                <Gettext>
                  A tournament account is an account, which becomes accessible
                  after the beginning of a tournament in case you've registered
                  in it.
                </Gettext>
              </Text>
              {/* prettier-ignore */}
              <Text>
                <Gettext>
                  You perform deals using a virtual currency named {<CurrencySymbol
                  currency={tournamentCurrency}/>} while
                  participating in a tournament. It is not directly associated with
                  real funds. In tournaments, you may only spend real funds for a
                  participation fee or for buying extra tournament coins. You may
                  switch to your tournament account on a page with the list of your
                  accounts on the platform.
                </Gettext>
              </Text>
              <Image src={`${images(isMobile)}/1.png`} />
              <Text>
                <Gettext>
                  You should press the "Register" button on a page with the list
                  of tournaments or any other page in order to sign up for a
                  tournament. Also, you should possess the sufficient amount of
                  money on your real account to cover a participation fee.
                </Gettext>
              </Text>
              <Image src={`${images(isMobile)}/2.png`} />
              <Image src={`${images(isMobile)}/3.png`} />
              <Image src={`${images(isMobile)}/4.png`} />
              <Image src={`${images(isMobile)}/5.png`} />
            </Item>
            <Item>
              <Text>
                <Gettext>
                  Refilling is a process of increasing your tournament account
                  balance via purchasing extra tournament coins. Refilling is
                  only possible if the amount of money on a tournament balance
                  and the amount of money in opened deals is no more than the
                  amount mentioned in the tournament rules.
                </Gettext>
              </Text>
              <Image src={`${images(isMobile)}/6.png`} />
            </Item>
            <Item>
              <Text>
                <Gettext>
                  A prize fund of each tournament is formed beforehand. It may
                  be fixed or depend on the amount spent by users to the
                  tournament. The rules of each tournament are mentioned on its
                  page. Moreover, each tournament has a guaranteed minimum prize
                  fund, which indicates the minimum amount to be shared among
                  the winners.
                </Gettext>
              </Text>
              <Image src={`${images(isMobile)}/7.png`} />
              <Image src={`${images(isMobile)}/8.png`} />
            </Item>
          </List>
        )}
      </Media>
    </Container>
  );
};

export default TextPage;



// WEBPACK FOOTER //
// ./src/components/Tournament/TextPage.js